var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mRank"
  }, [_c('div', {
    staticClass: "rank-main"
  }, [_c('div', {
    staticClass: "rank__title"
  }, [_vm._v(" Rankings ")]), _vm.ranking ? _c('div', {
    staticClass: "rank-list"
  }, _vm._l(_vm.ranking, function (item, index) {
    return _c('div', {
      staticClass: "rank-item"
    }, [_c('div', {
      staticClass: "rank-item__num"
    }, [_vm._v(_vm._s(index + 1))]), _c('div', {
      staticClass: "rank-item__img"
    }, [_c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "rank-item__name"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "rank-item__level"
    }, [_vm._v(" " + _vm._s("LV." + item.user_level) + " ")]), _c('div', {
      staticClass: "rank-item__r"
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.to_next_progress * 100)) + "%")])]);
  }), 0) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };